// 只针对vue hash，不通用
function addQueryString(key, value, uri) {
  if (!uri) {
    return ''
  }

  const parts = uri.split('#/')

  const link = parts[0]
  const separator = link.indexOf('?') !== -1 ? '&' : '?'
  const hash = parts[1] || ''
  return `${link + separator + key}=${value}#/${hash}`
}

export default addQueryString
